"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";

/**
 * Mounts PostHog on every first-party page so pageviews are captured across the
 * PUBLIC surfaces (content articles, the /map/ viewer, marketing) — not just the
 * signed-in editor, which is the only place the custom-event tracker previously
 * loaded posthog-js. Init sets `capture_pageview: "history_change"`, so posthog
 * handles the initial pageview AND App Router soft navigations itself; this
 * component only needs to trigger the one-time init. Renders nothing.
 *
 * Two deliberate choices keep posthog-js OUT of the embed bundle (FAIL-448):
 *  - the analytics client is DYNAMICALLY imported, so posthog-js code-splits into
 *    its own lazy chunk instead of the shared bundle every route loads; and
 *  - it never initializes on `/embed/*` — embeds render on third-party sites where
 *    running our analytics SDK is both unwanted and pure bundle weight (embed share
 *    events are already recorded server-side).
 */
export function PosthogBootstrap() {
  const pathname = usePathname();
  useEffect(() => {
    if (pathname?.startsWith("/embed")) return;
    void import("@/lib/analytics/client").then((m) => m.ensurePosthogInitialized());
  }, [pathname]);
  return null;
}
